// GENERATED by scripts/import-deck.mjs from
// Working Draft - Workshop Deck Template.pptx
// Do not edit by hand: re-run the importer when the source deck changes.
import type { SourceDeck } from '../../modules/decks/sourceDeck';

export const workshopDeck: SourceDeck = {
  "name": "Working Draft - Workshop Deck Template.pptx",
  "slides": [
    {
      "id": "s1",
      "title": "Workshop Deck Title Here",
      "bullets": [
        "Cisco’s approach to AI-era cyber defense",
        "June 2026"
      ],
      "notes": "Key takeaways\nFrame the conversation as an operating-model shift, not a product pitch.\nCisco's perspective is shaped by frontier-AI partnerships, our own internal practice, and customer reality.\nThe goal is how the customer operates differently going forward.\nSample script\n”Frontier AI models have changed the assumptions every security and infrastructure team had been working from. What I'd like to do today isn't walk you through a product list, it’s to share how Cisco is thinking about the next operating model for critical infrastructure, and where we see organizations needing to move first. This is a point of view, and I'd value your reactions as we go.\"\nTransition\n\"Let's start with what's actually changed, because frontier AI hasn't just made attackers faster. It's created an entirely new level of risk.\""
    },
    {
      "id": "s2",
      "title": "Agenda",
      "bullets": [
        "Introduction",
        "Frontier AI Challenge",
        "What is Cisco Doing?",
        "Practical Strategies for Mitigating Risk",
        "Centralize Your Inventory & Determine Exposure",
        "Focused, Prioritized Refresh and Upgrades",
        "Segment and Contain to Shrink the Blast Radius",
        "Temporary Migitation when Upgrades Can’t Happen Yet",
        "Elevate your Security Posture",
        "Resilient Infrastructure Services"
      ],
      "notes": "Our role is to help customers understand what is coming in the threat landscape\nAging infrastructure (EoL, inability to patch)\nAttacks on network infrastructure (at the edge)\nAI models (lowering the barrier of attack, speed + scale)"
    },
    {
      "id": "s3",
      "title": "Introduction",
      "bullets": [],
      "notes": ""
    },
    {
      "id": "s4",
      "title": "Ageing/Unpatched Infrastructure -> Achilles Heel",
      "bullets": [
        "40%",
        "of the top 100 targeted vulnerabilities impacted end-of-life systems",
        "48%",
        "of network assets worldwide have aged or now obsolete",
        "32%",
        "directly impacted",
        "are at least 10 years old​",
        "23%",
        "directly impacted network infrastructure devices",
        "Sources: Talos Year in Review, Update Critical Cisco Report",
        "AI Models will Weaponize Vulnerabilities​"
      ],
      "notes": ""
    },
    {
      "id": "s5",
      "title": "Talos blog: Salt Typhoon used CVEs previously disclosed",
      "bullets": [
        "All three CVEs have patches available. Patching HIGHLY Recommended",
        "Feb 20, 2025, https://blog.talosintelligence.com/salt-typhoon-analysis/"
      ],
      "notes": "Brad\n- Talos year end report"
    },
    {
      "id": "s6",
      "title": "And then the Catalytic Crisis Arrived",
      "bullets": [
        "The expected governance transition compressed from months or a year into four weeks.",
        "WebMCP standardized a browser-session path around MCP gateways.",
        "OpenClaw put highly capable, weakly governed agents everywhere. Then it got hacked.",
        "Mythos showed autonomous zero-day discovery and exploit as emergent capability.",
        "Mar 11",
        "Paper: crisis had not happened yet",
        "Week 1",
        "WebMCP",
        "Week 2",
        "OpenClaw",
        "OpenClaw Hacked",
        "Week 4",
        "Mythos",
        "Operational takeaway",
        "Governance was designed for a slower capability adoption curve and fewer access paths.",
        "Source: tamedautonomy.ai/catalytic-crisis. By Robin Martherus",
        "Week 3",
        "Everyone tries to block it"
      ],
      "notes": "Key takeaways\nTime-to-exploit has collapsed: 2.3 years (2018) → 4.2 months (2023) → 21.5 days (2025) → 8 hours (2026), and each model release pushes it further.\nThis is not a one-time patch event, every new model release improves vulnerability discovery, so the baseline keeps resetting.\nThe compounding reality: more vulnerabilities, weaponized even faster, with even specialized/obscure environments now exposed.\nSample script\n\"The data tells the story. In 2018, defenders had over two years between a vulnerability being disclosed and it being weaponized. Today it's measured in hours, and the trend line is still heading down. Frontier AI is allowing people to find more vulnerabilities, weaponize them faster, and reach environments people used to assume were safe simply because they were obscure. And this isn't a wave you ride out. Every new model release improves discovery and resets the baseline higher. The takeaway is simple: this is no longer a patching problem. It's an operating-model problem.\"\nTransition\n\"And that problem is compounded, because most organizations are facing this new threat with infrastructure and processes built for the old world.\""
    },
    {
      "id": "s7",
      "title": "What are the new risks?",
      "bullets": [
        "The First of Many Waves!",
        "Any program we build must acknowledge Mythos is only the first wave of future AI technology disruptions.",
        "Recommended Reading - The “AI Vulnerability Storm”: Building a “Mythosready” Security Program",
        "ZeroDayClock"
      ],
      "notes": "Key takeaways\nTwo compounding realities: aging infrastructure and slow processes.\n40% of the 100 top-targeted vulnerabilities hit end-of-life systems, and the most-targeted classes are network/edge appliances, trust systems, and embedded frameworks.\nThe median time to patch critical known-exploited vulnerabilities (KEVs) is 43 days, an eternity when exploitation happens in hours.\nSample script\n\"Two problems here, and they compound. First, aging infrastructure: 40% of the hundred most-targeted vulnerabilities last year hit end-of-life systems, concentrated exactly where it hurts most: network and edge appliances, trust systems, embedded frameworks. Second, slow processes: the median time to patch a critical, known-exploited vulnerability is 43 days. Sit with that. Exploitation now happens in hours, and the typical response still takes six weeks. That gap (between attacker speed and defender speed) is the whole problem in one number.\"\nTransition\n\"So if the old way no longer works, what does the new approach actually look like?\""
    },
    {
      "id": "s8",
      "title": "1",
      "bullets": [
        "Discovery is the bottleneck: with AI, discovery is no longer the rate limit. Everything else in the process is the bottleneck.",
        "1 CVE = 1 vulnerability: with AI finding hundreds of vulnerabilities in a single code pass, we must rethink the unit of disclosure itself",
        "Human speed patching will suffice: if discovery and exploitation is moving at machine speed, remediation must move at machine speed.",
        "3 Assumptions Broken"
      ],
      "notes": "Key takeaways\nThe shift: from \"harden it, prove it, don't touch it\" to \"harden it, prove it, continuously defend it at machine speed.\"\nThree dimensions change, Cadence (continuous CI/CD-style readiness vs. 12–24 month upgrades), Modernization (continuously remove what can't be made safe vs. running aging gear indefinitely), and Security Posture (continuous exposure reduction and containment vs. documented risk exceptions).\nThe unifying idea is continuity, defense becomes an ongoing loop, not a periodic event.\nSample script\n\"For decades the model was: harden it, prove it, don't touch it. Major upgrades every year or two. Aging gear kept in service. And a long list of documented risk exceptions you hoped no one would find. That worked when adversaries needed months. The post-Mythos model is: harden it, prove it, and continuously defend it at machine speed. Look down the right column, the word that repeats is 'continuous.' Cadence becomes CI/CD-style release readiness. Modernization becomes continuously removing what can't be made safe. And posture becomes continuous exposure reduction and containment. The whole thing moves from an event you survive to a loop you run.\"\nTransition\n\"This is exactly the shift Cisco is helping customers make, and it starts with how we're meeting this moment ourselves.\""
    },
    {
      "id": "s9",
      "title": "Frontier AI models are creating an entirely new level of risk",
      "bullets": [
        "THE AVERAGE TIME TO EXPLOIT VULNERABILITIES",
        "Sources: Cisco Blog, “Strengthening the Foundation: A Predictable, Customer focused Response to AI-Accelerated Vulnerability Discovery, ” April 7, 2026; zerodayclock.com, June 23,2026",
        "2018",
        "2.3 years",
        "2023",
        "4.2 months",
        "2025",
        "21.5 days",
        "2026",
        "8 hours",
        "Not a one-time patch event",
        "Each new model release will improve vulnerability discovery",
        "Vulnerabilities weaponized at scale",
        "More vulnerabilities",
        "Weaponized even faster",
        "Even specialized environments exposed"
      ],
      "notes": "So concretely, what is Cisco doing about this? Four things, and they build on each other.\nFirst, industry collaboration and leadership -- Cisco is working directly with frontier AI labs, including Anthropic through Project Glasswing and OpenAI through Trusted Access for Cyber, to proactively identify, triage, and remediate vulnerabilities at AI-speed, before they become public disclosures.\nWe are using early access to these same frontier models to go back through our own existing codebase and find and fix issues before adversaries do.\nThird, development integration -- we're building these models directly into our software development lifecycle so new code gets scanned for issues as it's written, not after.\nFourth, delivering that same capability outward to customers -- tools like Foundry Spec, CodeGuard, Live Protect, Hybrid Mesh Firewall with Hypershield, AI Defense, Agentic SOC, and AgenticOps -- so customers can prevent, detect, and respond to threats at machine speed too.\nUnderneath all of this is resilient infrastructure work: tightening default configurations, deprecating insecure legacy capabilities, and shipping new security features across the portfolio. I'll go deep on the pieces most relevant to a technical audience next, starting with Foundry."
    },
    {
      "id": "s10",
      "title": "Yesterday’s infrastructure and operating model are not ready for AI-era cyber threats",
      "bullets": [
        "Sources: Talos Year in Review",
        "DBIR Key topics and findings 2026",
        "Aging infrastructure",
        "40%",
        "of the 100 top-targeted vulnerabilities hit end-of-life systems across network, edge, identity, & embedded frameworks",
        "Slow processes",
        "43 days",
        "median time to patch critical known-exploited vulnerabilities (KEVs)"
      ],
      "notes": "Project Glasswing (new initiative by Anthropic) and a coalition of 12+ major tech companies which gives access to this model (Mythos Preview) to test and harden their own systems\nCisco’s Role:\nUsing Anthropic’s AI models to stress-test and improve Cisco’s security infrastructure, accelerating security product development\nCisco is collaborating through project glassing to turn Mythos’s offensive capabilities into accelerating the security improvements for it’s infra/products, and fostering a community-based approach to cybersecurity defense (which can be more effective than isolated efforts)"
    },
    {
      "id": "s11",
      "title": "Organizations need a different approach",
      "bullets": [
        "THE OLD APPROACH",
        "Harden it, prove it, don’t touch it",
        "THE POST-MYTHOS APPROACH",
        "Harden it, prove it, continuously defend it at machine speed",
        "CADENCE",
        "Major upgrades every 12–24 months",
        "Continuous, CI/CD-style release readiness",
        "MODERNIZATION",
        "Aging gear, protocols, and scripts kept in service",
        "Continuous removal of what can’t be made safe",
        "SECURITY POSTURE",
        "Documented risk exceptions",
        "Continuous exposure reduction and containment"
      ],
      "notes": "Sources:\n“Rising to the Era of AI-Powered Cyber Defense,” April 2026 - https://blogs.cisco.com/news/rising-to-the-era-of-ai-powered-cyber-defense\n“Announcing Foundry Security Spec,” May 2026 - https://blogs.cisco.com/ai/announcing-foundry-security-spec\n“Cisco donates Project CodeGuard to the Coalition for Secure AI,” February 2026 - https://blogs.cisco.com/ai/cisco-donates-project-codeguard-to-the-coalition-for-secure-ai\nResilient infrastructure: https://www.cisco.com/c/en/us/about/trust-center/resilient-infrastructure.html\nKey takeaways\nThis slide is about leadership in how to use frontier AI, not the customer-innovation story.\nFour proof points: pioneering frontier-AI vulnerability discovery (Project Glasswing and OpenAI Daybreak); open-sourcing Foundry Security Spec (a methodology for finding vulnerabilities at scale); sharing Project CodeGuard (secure-by-default rules for AI coding workflows); and redefining default security with a new standard for resilient infrastructure\nThe Grieco quote frames the ethos: security is a team sport, we lead by sharing, not hoarding.\nSample script\n”Security has always been a team sport, and the strongest defenders have never worked in isolation.\nWe're pioneering how frontier AI can find and fix vulnerabilities at speed and scale, through Project Glasswing and OpenAI Daybreak. But we're not keeping the method to ourselves.\nWe've open-sourced Foundry Security Spec, a methodology for finding vulnerabilities at scale\nAnd shared Project CodeGuard, which builds secure-by-default rules into AI coding workflows.\nAnd finally, we are redefining default security by setting a new standard for resilient infrastructure and sharing that with you. Resilient infrastructure is a Cisco effort to strengthen network security by increasing default protections, removing legacy insecure features, and introducing advanced security capabilities\nThe point isn't just that Cisco is good at this. It's that we're setting a standard the whole industry can build on.\"\n(Seller note: Foundry is a blueprint/spec (the design for building an evaluation system) not a turnkey scanner. CodeGuard \"steers toward\" secure-by-default patterns; it's defense-in-depth, not a guarantee.)\nTransition\n\"And here's the part that earns the right to make those claims, we hold ourselves to this same standard first.\""
    },
    {
      "id": "s12",
      "title": "How Cisco is Addressing the Challenge",
      "bullets": [
        "Industry collaboration and leadership",
        "Existing code remediation",
        "Development integration",
        "Delivering customer innovation to address threats",
        "Resilient Infrastructure"
      ],
      "notes": "Sources:\n“8 years of security research in 8 weeks: Transforming cybersecurity with AI,” June 2026 - https://blogs.cisco.com/news/8-years-of-security-research-in-8-weeks-transforming-cybersecurity-with-ai\nResilient infrastructure: https://www.cisco.com/c/en/us/about/trust-center/resilient-infrastructure.html\nKey takeaways\nThe 1.8B-lines scan (8 weeks vs. 8 years of manual work) is the headline proof, but it's the opening of a broader story, not the whole story.\nResilient Infrastructure is the superset: beyond fixing code, Cisco is raising products' baseline security (stronger defaults, fewer legacy features, enhanced visibility, hardened access) and publishing on a predictable cadence.\nThis predates Mythos, it's a long-held, ongoing commitment to engineer products against tomorrow's attacks, including AI-driven ones we hadn't yet named.\nNet to the customer: what you run from Cisco arrives already hardened, because we hold ourselves to this standard first.\nSample script\n\"The proof that we hold ourselves to the standard we set: in just eight weeks, we scanned 1.8 billion lines of code across 25-plus languages spanning our portfolio, work that would have taken our research team eight years. We find and fix at the root, before code ships. But (and this is the important part) that scan is the most visible piece of something much larger. Through our Resilient Infrastructure program we're raising the baseline security of every product: stronger defaults, fewer legacy features, deeper visibility, hardened access, and publishing security updates on a predictable cadence you can plan around. And none of this started with Mythos. We've been engineering our products to withstand tomorrow's attacks for years, including the AI-driven threats we hadn't yet named. The takeaway for you is simple: what you run from Cisco arrives already hardened, because we hold ourselves to this standard first.\"\nTransition\nIf transitioning to slide 9 (“Security hardening as a regular release cadence”): \"And that scheduled cadence isn't incidental, it's a deliberate shift in how we deliver security to you. Let me show you what it looks like in practice.”\nIf transitioning to slide 10 (“Elevating security posture”): \"That's what we do at the source and how we deliver it. Now let's talk about how that defense shows up fused into the network you operate.\""
    },
    {
      "id": "s13",
      "title": "Project Glasswing",
      "bullets": [
        "Project Glasswing Overview",
        "Real-time mitigation + shared defense",
        "A $100M+ initiative bringing together major tech companies to secure critical software using Anthropic's Claude Mythos Preview for proactive vulnerability discovery and exploitation.",
        "Launch Partners",
        "AWS",
        "Anthropic",
        "Apple",
        "Broadcom",
        "Cisco",
        "CrowdStrike",
        "Google",
        "JPMorganChase",
        "Linux Foundation",
        "Microsoft",
        "NVIDIA",
        "Palo Alto",
        "Real-time Mitigation",
        "Coordinated Defense",
        "Global Reach",
        "Cisco's Strategic Role",
        "Embedded active defense",
        "Stress-Test Infrastructure",
        "Using Anthropic's AI models to rigorously test, identify vulnerabilities, and harden Cisco products and infrastructure.",
        "Accelerate Security Development",
        "Turning Mythos's offensive capabilities into faster, proactive security improvements across the entire product suite.",
        "Project Glasswing: Coordinated defense against AI-accelerated threats"
      ],
      "notes": "Source:\n“Strengthening the Foundation: Predictable, Customer focused Response to AI-Accelerated Vulnerability Discovery,” June 2026 - https://blogs.cisco.com/security/strengthening-the-foundation-a-predictable-customer-focused-response-to-ai-accelerated-vulnerability-discovery\nKey takeaways\nThe most effective protection is running a current, hardened release, not patching findings one at a time, CVE-by-CVE (Smoak).\nDelivered through a predictable rhythm: scheduled cadence, advance notice of affected platforms, and quarterly core NOS updates (IOS XE, IOS XR, NX-OS, Firepower/ASA, SD-WAN).\nBundled CVEs group systemic hardening by weakness category rather than as one-off fixes, a shift toward release-level assurance, not reduced transparency; individual CVEs are still issued when a vulnerability demands defender action.\nCaveat to voice: critical issues are addressed out of cycle, as needed, predictable doesn't mean rigid.\nSample script\n\"Russ Smoak puts it plainly: assessing risk CVE-by-CVE and applying point mitigations is no longer fit for purpose, the best protection is running a current, hardened release. So we've made our releases predictable: a scheduled cadence (with critical issues handled out of cycle), advance notice of affected platforms, and quarterly core updates across the operating systems you run. One change to be direct about, because hardened releases carry systemic, pervasive fixes, we now bundle CVEs by weakness category rather than one per bug. That's release-level assurance, not less transparency; when a vulnerability needs your action, we still issue an individual CVE with full detail. We recognize this shifts emphasis from per-issue detail toward release-level assurance, but this is where the infrastructure industry must move towards defending against this new landscape.”\nTransition\n\"That's what we do at the source and how we deliver it. Now let's see how that defense shows up in your environment, elevating your security posture.\""
    },
    {
      "id": "s14",
      "title": "Setting the standard",
      "bullets": [
        "Industry leadership",
        "Security has always been a team sport, and the defenders who have protected this industry for decades have never succeeded by working in isolation. We have succeeded by sharing threat intelligence, raising the alarm when needed, and showing up for each other when the stakes are highest.",
        "Anthony GriecoSVP and Chief Security & Trust Officer, Cisco",
        "Pioneering how frontier AI finds and fixes vulnerabilities at speed and scale(Project Glasswing and OpenAI Daybreak)",
        "Open-sourcing Foundry Security Spec, a methodology for finding vulnerabilities at scale",
        "Sharing Project CodeGuard, which helps buildsecure-by-default rules into AI coding workflows",
        "Redefining default security by setting a new standard for resilient infrastructure",
        "Source: Cisco Blog, “Rising to the Era of AI-Powered Cyber Defense,” April 2026"
      ],
      "notes": "This is Foundry Security Spec -- and I want to be precise about what it is, because the name undersells it. It's a specification, open at github.com/CiscoDevNet/foundry-security-spec, that defines how to build your own AI-agent harness for testing your environment and software far more rigorously than ad hoc prompting ever could. This is exactly what security teams experimenting with AI models have been trying to hand-roll on their own -- Foundry gives you the structure instead.\nIt's designed to work in a closed loop with Project CodeGuard: Foundry's detector role finds vulnerabilities, and CodeGuard rules prevent that same class of bug from being written in the first place, right inside a developer's coding tool.\nFoundry formalizes that into a proper specification: a defined architecture, a set of roles, a lifecycle for findings, and a shared coordination system, so the result is verifiable findings instead of noisy, unreliable AI output."
    },
    {
      "id": "s15",
      "title": "Holding ourselves to the same standard first",
      "bullets": [
        "Hardening of our own systems",
        "Assessing entire codebases at scale, finding vulnerabilities before release and remediating defects at the root",
        "Publishing security updates on a predictable, scheduled cadence that aligns with planned maintenance",
        "Raising our products' baseline security: stronger defaults, fewer legacy features, enhanced visibility, and hardened access",
        "Continuing our long-held commitment to constantly evolve and raise our own standards for resilient infrastructure",
        "In just eight weeks, we scanned 1.8 billion lines of code in over 25 coding languages across the breadth of Cisco’s portfolio, a process that would have taken our world-class security research team eight years to complete. We are only getting started.",
        "Anthony GriecoSVP and Chief Security & Trust Officer, Cisco",
        "Source: Cisco Blog, “8 years of security research in 8 weeks: Transforming cybersecurity with AI,” June 2026"
      ],
      "notes": "Let's go under the hood. Foundry defines eight core agent roles, and the design principle is that each role exists specifically to catch the previous role's failure mode –\nThis is the key design idea: it's not eight agents doing the same task in parallel, it's a pipeline where each stage exists specifically to correct the weaknesses of the stage before it.\nThe Orchestrator handles the lifecycle and conversational layer -- the coordination brain.\nThe Indexer builds a searchable knowledge base of your code.\nThe Cartographer maps your architecture and trust boundaries -- where does data cross a privilege boundary.\nThe Detector sweeps using a rule corpus combined with open-ended exploration -- your first pass at candidate issues.\nThe Triager investigates those candidates and reduces false positives, because a raw detector pass is noisy.\nThe Validator confirms findings with actual evidence before anything gets published -- the gate against hallucinated vulnerabilities.\nThe Coverage-Guide tracks what's actually been examined so you know your blind spots, not just your findings.\nAnd the Reporter publishes triaged, deduplicated findings.\nAll eight roles coordinate through a shared substrate -- a common work queue, a finding store, a sandbox for safe execution, a budget system, and a dashboard. That substrate is what keeps this from becoming eight disconnected tools."
    },
    {
      "id": "s16",
      "title": "A predictable, customer-focused response",
      "bullets": [
        "Hardening our own systems",
        "Assessing security risk CVE-by-CVE and applying point mitigations is no longer fit for purpose. The most effective protection is running a current, hardened release, not patching individual findings across older ones.",
        "Russ SmoakVP, Information Security, Security Assurance & Response, Cisco",
        "Scheduled cadence: 1st and 3rd Wednesday",
        "Advance notice: affected platforms announced 7 days ahead",
        "Quarterly core NOS updates: IOS XE, IOS XR, NX-OS, Firepower/ASA, SD-WAN",
        "Bundled CVEs: systemic hardening grouped by weakness category, not just one-off fixes",
        "Note: Critical issues are addressed out of cycle, as needed",
        "Source: Cisco Blog, “Strengthening the Foundation: Predictable, Customer focused Response to AI-Accelerated Vulnerability Discovery,” June 2026"
      ],
      "notes": "Beyond the eight core roles, the spec defines five optional extension roles -- but notice something deliberate in the design: the seed, the reference implementation guidance, recommends 'no' to building all five on your first pass. Get the eight core roles producing trustworthy findings first, then revisit. That's a discipline decision, not a limitation -- it's very easy to over-build an agentic pipeline before you've proven the foundation is reliable.\nThe five extensions, when you're ready:\nDeep-Tester drills into high-signal targets with slower, deeper analysis.\nVariant-Hunter takes a confirmed bug and finds its siblings elsewhere in the codebase, because vulnerabilities rarely exist in isolation.\nAttack-Mapper builds an attack graph linking findings to actually reachable paths, which is what turns a finding into a prioritized finding.\nRemediator drafts patches against confirmed findings for human review -- notice: for review, not auto-merge.\nAnd Self-Improver closes the loop by turning missed bugs into new detection rules, so the system improves over time instead of staying static."
    },
    {
      "id": "s17",
      "title": "Foundry Security Spec",
      "bullets": [
        "github.com/CiscoDevNet/foundry-security-spec",
        "Build on it.",
        "Adapt it.",
        "Contribute.",
        "From Noisy Alerts to Verifiable Security Findings"
      ],
      "notes": "Foundry ships as two artifacts, and they serve very different purposes.\nSPEC.MD is the spec -- the seed. It defines the eight core roles, the five extensions, the full finding lifecycle, the coordination substrate, and roughly 130 functional requirements, each with an inline rationale explaining why that requirement exists -- not just what to build, but why it matters.\nCONSTITUTION.MD is the constitution -- the rules. Eleven inviolable principles, and this is the part I'd draw your attention to as engineers: each one of those eleven principles encodes a real production failure that Cisco shipped, diagnosed, and fixed internally. They're written so an engineer sees the cost of violating the rule before they're tempted to weaken it.\nSo: two artifacts, but the lessons baked into them are the output of real incidents, not theoretical best practice."
    },
    {
      "id": "s18",
      "title": "Foundry Security Spec: Architecture",
      "bullets": [
        "Orchestrator",
        "Lifecycle + conversational layer",
        "Indexer",
        "Builds searchable code knowledge",
        "Cartographer",
        "Maps architecture & trust boundaries",
        "Detector",
        "Sweeps with rule corpus + exploration",
        "Triager",
        "Investigates, reduces false positives",
        "Validator",
        "Confirms with evidence before publish",
        "Coverage-Guide",
        "Tracks what's been examined & gaps",
        "Reporter",
        "Publishes triaged, deduplicated findings",
        "All roles coordinate through a shared substrate, work queue, finding store, sandbox, budget, dashboard.",
        "Eight core roles, each catching the previous one's failure mode."
      ],
      "notes": "Foundry doesn't operate in isolation -- it consumes a rule and skills corpus, and that corpus is Project CodeGuard, at project-codeguard.org.\nFoundry’s Detector role is driven by a rule and skills corpus, and that corpus is Project CodeGuard. This creates a closed loop: Foundry's Detector finds vulnerabilities using CodeGuard's rules, and those same CodeGuard rules also run inside developers' coding tools to prevent that class of bug from being written in the first place.\nWhere it lives matters too: Cisco open-sourced CodeGuard before Foundry even existed, then donated it to the Coalition for Secure AI, CoSAI, where it's now an OASIS open project.\nFor anyone unfamiliar with CoSAI: it's an industry consortium -- not a Cisco-run body -- focused on best practices and open tooling for securing AI systems, with membership spanning major tech and security vendors including Google and Microsoft. The point of donating CodeGuard there is that it becomes a shared, vendor-neutral industry baseline rather than a Cisco-proprietary asset. And because the rules are portable, that same corpus loads directly into LLM coding assistants as prevention guardrails -- independent of whether you're running Foundry at all."
    },
    {
      "id": "s19",
      "title": "Foundry Security Spec: Optional Capability",
      "bullets": [
        "The seed recommends \"no\" to all five on the first build.",
        "Get the eight core roles producing trustworthy findings, then revisit.",
        "Deep-Tester",
        "Drills into high-signal targets with deeper, slower analysis",
        "Variant-Hunter",
        "Finds variants of confirmed bugs across the codebase",
        "Attack-Mapper",
        "Builds an attack graph linking findings to reachable paths",
        "Remediator",
        "Drafts patches against confirmed findings for human review",
        "Self-Improver",
        "Closes the loop, turns missed bugs into new detection rules",
        "Five extension roles, build them after the core works.",
        "Foundry Security Spec: Optional Capability"
      ],
      "notes": ""
    },
    {
      "id": "s20",
      "title": "Foundry Security Spec: The Deliverables",
      "bullets": [
        "SPEC.MD",
        "The Spec",
        "The seed",
        "Eight core agent roles, five extensions, finding lifecycle, coordination substrate, and ~130 functional requirements, each with an inline rationale explaining why it exists.",
        "CONSTITUTION.MD",
        "The Constitution",
        "The rules",
        "Eleven inviolable principles. Every one encodes a real production failure Cisco shipped, diagnosed, and fixed, written so engineers see the cost before they weaken a rule.",
        "Two artifacts. Numerous lessons learned."
      ],
      "notes": ""
    },
    {
      "id": "s21",
      "title": "Foundry Security Spec: The Companion",
      "bullets": [
        "project-codeguard.org",
        "CodeGuard",
        "The rule and starting agent skills corpus Foundry consumes",
        "WHAT IT DOES",
        "Secure-by-default rules for AI coding agents",
        "Comprehensive security rules + agent skills that guide coding agents to generate safer code.",
        "In Foundry, the same corpus drives the Detector role, and grows as new bug classes are discovered.",
        "WHERE IT LIVES",
        "Donated to the Coalition for Secure AI (CoSAI)",
        "Cisco open-sourced CodeGuard before Foundry, then donated it to CoSAI, now an OASIS open project.",
        "Portable rules: the same corpus loads into LLM coding assistants as prevention guardrails."
      ],
      "notes": ""
    },
    {
      "id": "s22",
      "title": "Project CODEGUARD",
      "bullets": [
        "Apply Rules",
        "Implement CodeGuard rules during code creation to prevent security issues.",
        "Scan Code",
        "Conduct comprehensive code scanning to identify potential issues early.",
        "Review PRs",
        "Integrate CodeGuard rules into pull request reviews to enhance code quality and security.",
        "Automated Security",
        "The Result: Secure code development.",
        "https://project-codeguard.org"
      ],
      "notes": "Key takeaways\nFour AI-era problems, each with a matched capability: a compressed exploit window (hours or less); unnecessary access that opens vulnerable systems and lateral paths; hidden identity weaknesses that turn footholds into breaches; and attacks moving faster than analysts can react.\nFour solutions: vulnerability identification & shielding (time-bound compensating controls); distributed segmentation & containment (across network, IoT, cloud, workloads, applications); identity visibility & security (find weak, dormant, overprivileged human, machine, and agent identities and enforce strong authentication, posture, and governance); and agentic security operations (unify cross-domain data to detect, investigate, and respond at machine speed).\nThese aren't bolt-on point products, they're layered capabilities, simplified through Cisco Cloud Control and AgenticOps.\nSample script\n\"This is how you elevate security posture in practice, four problems, four answers.\nFirst, the exploit window has compressed to hours or less, so we get ahead of it: vulnerability identification and shielding lets you understand your attack surface and apply compensating controls as time-bound mitigation while a real fix is prepared.\nSecond, unnecessary access exposes vulnerable systems and opens lateral paths, so we limit reachability and contain compromise with distributed segmentation across network, IoT, cloud, workloads, and applications.\nThird, hidden identity weaknesses are what turn a small foothold into a full breach, so we find the weak, dormant, and overprivileged identities, whether human, machine, or agent, and enforce strong authentication, posture, and governance.\nAnd fourth, attacks move faster than any analyst can react, so agentic security operations unify cross-domain data to detect, investigate, and respond at machine speed and scale.\nThe important point: these aren't products you bolt together. They're layered capabilities, simplified through Cisco Cloud Control and AgenticOps.\"\nTransition\n\"Knowing what to do is one thing, sequencing it is another. Here's a suggested playbook for defending your organization.\""
    },
    {
      "id": "s23",
      "title": "Each Open Source initiative solves a problem",
      "bullets": [
        "Three independent Cisco open source projects. Any one of them is useful without the other two.",
        "OPEN SOURCE",
        "PREVENTION",
        "Project CodeGuard",
        "THE PROBLEM",
        "Coding agents write more code, and more vulnerabilities with it",
        "A community ruleset, plus translators for the popular coding agents",
        "Steers the assistant to secure code as it is written",
        "Donated by Cisco to CoSAI",
        "Runs as: rules and skills in your repo",
        "DETECTION",
        "Antares",
        "Analysts don't know where in a large repo to start looking",
        "Give it a CWE; it returns a ranked list of suspect files",
        "350M and 1B open weights on Hugging Face, 3B to follow",
        "The repository never leaves your network",
        "Runs as: a CLI on one local GPU, wired into CI/CD",
        "GOVERNANCE",
        "Foundry Security Spec",
        "Point a frontier model at a repo and you get unverifiable output",
        "Eight agent roles, a finding lifecycle, ~130 requirements",
        "Eleven principles, each from a real production failure",
        "A blueprint you implement, not a scanner you install",
        "Runs as: a spec you build out with GitHub spec-kit",
        "EFFORT TO ADOPT, YOU CAN START ANYWHERE",
        "Drop-in",
        "Add the ruleset to the coding agents your developers already run",
        "Pull and run",
        "Fetch the weights from Hugging Face and scan on your own hardware",
        "Design and build",
        "The spec is the starting point; the implementation is yours to own",
        "Sources: Cisco Blogs, “Announcing Foundry Security Spec” (May 2026), “Introducing Antares” (Jul 2026); project-codeguard.org"
      ],
      "notes": ""
    },
    {
      "id": "s24",
      "title": "Better Together - A harness, a model, and the rules that feed both",
      "bullets": [
        "Composed, they stop being three tools, the harness contains the model, and the rules feed both sides",
        "OPEN SOURCE",
        "IN THE DEVELOPER'S IDE",
        "Project CodeGuard",
        "Secure-by-default rules for AI coding agents",
        "Rules and agent skills load into the coding assistant developers already use",
        "Prevents known weakness classes before code is ever committed",
        "Donated by Cisco to the Coalition for Secure AI (CoSAI)",
        "The same corpus feeds Foundry's Detector role",
        "THE HARNESS, EVERYTHING BELOW RUNS INSIDE IT",
        "Foundry Security Spec",
        "Wraps whatever model you use in orchestration, roles and guardrails",
        "EIGHT AGENT ROLES",
        "Orchestrator · Indexer · Cartographer · Detector · Triager · Validator · Coverage-Guide · Reporter",
        "THE MODEL SLOT, MODEL-AGNOSTIC",
        "Antares",
        "Ranks the files a given CWE most likely lives in",
        "350M / 1B open weights, one local GPU, code stays in-house",
        "WHAT COMES OUT",
        "A defensible finding set",
        "Bounded and prioritized, with a real \"done\" signal",
        "Audit provenance from detection through publication",
        "What the harness confirms that the rules missed becomes a new CodeGuard rule, prevented in every IDE",
        "WHAT THE ENTERPRISE ACTUALLY GETS",
        "Code stays in-house",
        "Local inference, no repo leaves the network",
        "Cheap enough for every commit",
        "A 500-task run: ~15 min on one GPU, under $1",
        "Defensible to auditors",
        "Provenance from detection to publication",
        "No vendor lock-in",
        "Open weights, open spec, swappable model",
        "Sources: Cisco Blogs, “Announcing Foundry Security Spec” (May 2026), “Introducing Antares” (Jul 2026); project-codeguard.org. Foundry is a specification, not a product, the model slot is yours to fill."
      ],
      "notes": "Key takeaways\nThe playbook organizes the journey across three tracks (advance your operating model for resilient infrastructure, modernize your infrastructure, and elevate your security posture) each run through Assess / Act / Optimize.\nIt's a structure for sequencing work, not a one-time project.\nMost customers start with Assess, because you can't prioritize what you can't see.\nSample script\n\"Everything we've discussed fits into one playbook with three tracks:\nAdvance your operating model for resilient infrastructure: Evolve your operating model so your business runs on the most resilient infrastructure\nModernize your infrastructure: Turn modernization into a strategic advantage: building for AI speed, scale, and threats\nElevate your security posture: Know every identity, limit, blast radius, and respond at machine speed and scale\nAnd each track runs through the same three moves, Assess what you have and where you're exposed, Act to reduce risk, and Optimize so each cycle is faster than the last. It's a structure for sequencing work, not a one-time project, and while it is a loop, most customers start with Assess, because you can't prioritize what you can't see.”\nTransition\n\"And assessment is exactly where our services begin. Here's how Cisco helps you act quickly and confidently.\""
    },
    {
      "id": "s25",
      "title": "Elevating security posture",
      "bullets": [
        "Customer innovation",
        "Problem:",
        "Solution:",
        "How Cisco helps:",
        "Identity visibility & security",
        "Find weak, dormant, and overprivileged human, machine, and agent identities. Enforce strong authentication, posture, and governance.",
        "Hidden identity weaknesses turn footholds into breaches.",
        "Identity Intelligence",
        "Duo IAM",
        "Identity Services Engine",
        "Splunk Exposure Analytics",
        "Distributed segmentation & containment",
        "Limit reachability and contain compromise by segmenting across network, IoT, cloud, workloads, and applications.",
        "Unnecessary access exposes vulnerable systems & lateral paths.",
        "Smart Switches",
        "Hybrid Mesh Firewall",
        "Zero Trust Network Access (SASE)",
        "Agentic security operations (SOC)",
        "Unify cross-domain data todetect, investigate, and respond to attacks at machine speed and scale",
        "Attacks move faster than analysts can react.",
        "Cisco Data Fabric",
        "Splunk Enterprise Security",
        "Talos threat intelligence",
        "Simplified operations with Cisco Cloud Control and AgenticOps",
        "Vulnerability identification & shielding",
        "Get ahead of vulnerabilities by understanding your attack surface and applying compensating controls as time-bound mitigation",
        "Exploit window has compressed to hours or less.",
        "Live Protect",
        "Snort IPS",
        "Cisco IQ"
      ],
      "notes": "Key takeaways\nThree phases mapped to Assess / Act / Optimize, anchored in Zero Trust: (1) Exposure Assessment, an AI-era readiness review with a prioritized action plan; (2) Infrastructure Modernization, structural hardening that contains blast radius and eliminates structural debt; (3) Defense Resiliency, a continuous, 24x7 hardening and monitoring framework.\nThe phases form an iterative cycle, not a strict sequence, but most customers start with exposure assessment.\nCisco brings 40 years of digitized understanding of customer infrastructure to bear.\nSample script\n\"True resilience is not a reaction. It is an architecture. A new offering, delivered through Cisco Support and Professional Services, helps customers identify vulnerable assets, modernize their operational capabilities, strengthen architecture with zero trust principles, and deploy agentic responses with a 3-phased approach.\nPhase one, Exposure Assessment for risk clarity, that's the Assess move: we evaluate your entire infrastructure, including aging assets and Zero Trust readiness, and hand you a prioritized action plan.\nPhase two, Infrastructure Modernization to enforce structural hardening, the Act move: we structurally harden the environment, containing blast radius and eliminating structural debt, drawing on 40 years of taking care of customer infrastructure.\nPhase three, Defense Resiliency for continuous, autonomous protection, the Optimize move: a continuous, 24x7 framework that keeps hardening against evolving threats.\nYou don't have to do all three at once, but exposure assessment is the fastest way to know where to start.\"\nTransition\n\"And you don’t have to do any of this alone. Our partner ecosystem can help, meeting you wherever you are on that journey.\""
    },
    {
      "id": "s26",
      "title": "LIVE PROTECT",
      "bullets": [
        "A Runtime Shield Embedded in the Network OS",
        "Cisco Live Protect is a runtime capability built directly into support platforms that applies Cisco-validated compensating controls to running infrastructure, between regular maintenance windows.",
        "Not a patch, a shield",
        "A temporary, targeted control that blocks one specific exploit path: a “finger in the dike” until a permanent fix ships.",
        "Zero disruption",
        "Applied to a live switch, no reboot, upgrade or maintenance window. CPU, memory and latency stay intact.",
        "Cisco-validated",
        "Shields are authored and tested by Cisco Talos and engineering, not do-it-yourself runtime rules written by operators.",
        "Mitigate an emerging CVE immediately, then patch on your own schedule."
      ],
      "notes": "Beyond the eight core roles, the spec defines five optional extension roles -- but notice something deliberate in the design: the seed, the reference implementation guidance, recommends 'no' to building all five on your first pass. Get the eight core roles producing trustworthy findings first, then revisit. That's a discipline decision, not a limitation -- it's very easy to over-build an agentic pipeline before you've proven the foundation is reliable.\nThe five extensions, when you're ready:\nDeep-Tester drills into high-signal targets with slower, deeper analysis.\nVariant-Hunter takes a confirmed bug and finds its siblings elsewhere in the codebase, because vulnerabilities rarely exist in isolation.\nAttack-Mapper builds an attack graph linking findings to actually reachable paths, which is what turns a finding into a prioritized finding.\nRemediator drafts patches against confirmed findings for human review -- notice: for review, not auto-merge.\nAnd Self-Improver closes the loop by turning missed bugs into new detection rules, so the system improves over time instead of staying static."
    },
    {
      "id": "s27",
      "title": "Guidance for defending the organization",
      "bullets": [
        "Act",
        "Optimize",
        "Assess",
        "Advance the operating model for resilient infrastructure",
        "Modernize the infrastructure",
        "Elevate the security posture",
        "A playbook of practical steps to protect the organization in the AI era:"
      ],
      "notes": "Actively exploited vulnerabilities: Prioritize devices impacted by a Common\nVulnerabilities and Exposures (CVE) entry on CISA’s Known Exploited\nVulnerabilities (KEV) list, regardless of tier. This means the vulnerability has\nbeen actively exploited in the real world and presents an imminent danger.\nInternet-facing devices: For example, Secure Routers, SD-WAN, IOS XR,\nand Secure Firewall are directly reachable and under the highest scan and\nexploit pressure. Defenders should aim to act immediately on internet-\nfacing devices following an advisory.\nCritical business support devices: Devices that support critical business\nfunctions, or serve as policy enforcement points, including third-party,\ncloud, and externally-facing connections. Modern applications and services\naccess resources dynamically, so visibility, accountability, and intent must\nbe prioritized."
    },
    {
      "id": "s28",
      "title": "Resilient Infrastructure Services: Act quickly and confidently",
      "bullets": [
        "Infrastructure Modernization",
        "Blast radius contained; structural debt eliminated",
        "We modernize their infrastructure, leveraging the digitized understanding we have built over 40 years of taking care of our customers.",
        "ASSESS",
        "OPTIMIZE",
        "Exposure Assessment",
        "AI-Era Readiness Review with prioritized action plan",
        "We evaluate the customer's entire infrastructure (including aging assets and Zero Trust readiness) to determine their security posture against these new attacks.",
        "Defense Resiliency",
        "24x7 monitoring framework against evolving threats",
        "We implement continuous, security/network hardening practices to ensure ongoing protection against evolving threats.",
        "DEFENSE RESILIENCY",
        "Continuous, Autonomous Defense",
        "ACT",
        "INFRASTRUCTURE MODERNIZATION",
        "Structural Hardening + Operational Agility",
        "EXPOSURE ASSESSMENT",
        "Delivery +",
        "Risk Mapping",
        "ZTP",
        "ZERO TRUST",
        "PRINCIPLES"
      ],
      "notes": ""
    },
    {
      "id": "s29",
      "title": "Practical Strategies for Mitigating Risk",
      "bullets": [],
      "notes": "Slide goal: Present the first step of the Resilient Infrastructure Services playbook in Cisco IQ, “Attack surface mapping”, as part of the Exposure Assessment pillar.\nKey takeaways:\nThis is the first step of Exposure Assessment: mapping the attack surface.\nIt starts with complete asset visibility, so nothing hides in the blind spots.\nIt surfaces EoL and LDoS status on every device, critical when forty percent of top-targeted vulnerabilities hit legacy systems.\nIt maps security advisories to the customer's specific environment, not a generic list.\nExample Talk Track:\n\"Attack surface mapping\" is the initial step of the Exposure Assessment pillar, which is featured in the Resilient Infrastructure Playbook on Cisco IQ.\nIt starts with complete asset visibility, so nothing hides in the blind spots.\nIt surfaces end-of-life and last-day-of-support status on every device, which is critical when top-targeted vulnerabilities hit legacy systems.\nIt then maps security advisories to your specific environment, so you see the exposures that apply to you rather than a generic list."
    },
    {
      "id": "s30",
      "title": "Mitigating Risk",
      "bullets": [
        "Assess",
        "Centralize Your Inventory & Determine Exposure",
        "Upgrade / Replace",
        "Focused, Priotized Refresh and Upgrades",
        "Secure",
        "Harness AI for defense",
        "Improving security posture for AI Era Cyber Defense",
        "Foundry Security Spec: Optional Capability",
        "Five extension roles, build them after the core works.",
        "Shield",
        "Temporary Migitation when Upgrades Can’t Happen Yet",
        "Segment",
        "Segment and Contain to Shrink the Blast Radius"
      ],
      "notes": "Slide goal: Present the second step of the Resilient Infrastructure Services playbook, the “Critical exposure remediation guidance”, which prioritizes critical vulnerabilities to remediate critical exposures.\nKey takeaways:\nAutomated, de-risked OS upgrades raise patch velocity and close the 43-day gap surfaced earlier (slide 5).\nExample Talk Track:\nThen we automate and de-risk the OS upgrade path, which raises your patch velocity and closes the 43-day gap we talked about earlier."
    },
    {
      "id": "s31",
      "title": "Centralize Your Inventory & Determine Exposure",
      "bullets": [
        "Why it matters: exposure isn't the same as running a vulnerable version, it's about reachability",
        "Build and maintain an up-to-date hardware and software inventory",
        "Tag internet-facing assets for expedited change approval",
        "Map advisories to affected products in your inventory",
        "Assess reachability and configuration, not just version",
        "Prioritize by exposure, reachability and business criticality, not severity score alone"
      ],
      "notes": "Slide goal: Deep-dive the third step, “Modernization lifecycle insights”, connecting exposure to modernization planning.\nKey takeaways:\nThe third step, Modernization lifecycle insights, turns exposure data into a proactive refresh plan, so the customer gets ahead of risk.\nIt starts with clear lifecycle status visibility across the fleet.\nIt maps lifecycle data to business risk impact, so the customer can justify decisions to budget holders.\nIt provides tailored remediation paths rather than generic advice, setting up the modernization work cleanly.\nExample Talk Track:\nThe third and last step, “Modernization lifecycle insights”, turns exposure data into a proactive refresh plan, so you get ahead of risk instead of reacting to it.\nIt starts with clear lifecycle status visibility across your fleet, and it maps that lifecycle data to business risk impact. It then gives you tailored remediation paths rather than generic advice, which sets up the modernization work cleanly."
    },
    {
      "id": "s32",
      "title": "Prioritize the Most Exposed First",
      "bullets": [
        "Risk dictates the priority; but context determines the plan of action",
        "Actively exploited vulnerabilities: Prioritize devices impacted by a Common Vulnerabilities and Exposures (CVE) entry on CISA’s Known ExploitedVulnerabilities (KEV) list.",
        "Internet-facing devices: Act immediately on internet-facing devices following an advisory.",
        "Critical business support devices: Devices that support critical business functions, or serve as policy enforcement points, including third-party, cloud, and externally-facing connections."
      ],
      "notes": ""
    },
    {
      "id": "s33",
      "title": "Cisco IQ",
      "bullets": [
        "Inventory management, vulnerability detection, and connecting to support services",
        "Consolidated Cisco asset inventory",
        "Security advisory assessents and device mapping",
        "Quantum readiness report",
        "Last date of support reporting",
        "Integrated AI insights",
        "Available to all CX customers with a valid Cisco Support contract."
      ],
      "notes": "Key Outcomes to focus on:\nOne policy, defined once in Cisco Cloud Control, enforced consistently across edge, campus, workload, and data center\nShields known vulnerabilities and stops advanced threats before they reach critical assets\nInspects encrypted traffic for malicious flows without full decryption\nStops unauthorized lateral movement across firewalls, smart switches, workload agents, and ISE\nExample Talk Track:\n\"Segmentation only works if the policy is consistent everywhere, otherwise attackers just find the gap between tools. Hybrid Mesh Firewall lets you define an intent-based zone once in Cloud Control and push it out to Secure Firewall, Secure Router, third-party firewalls, Smart Switches, workload agents, and ISE. Whether the risk is at the edge, in the campus, on a workload, or inside the data center rack, the same policy and the same Talos-informed enforcement applies.”\n3 questions to ask and what to listen for:\n\"How many different places do you define firewall or segmentation policy today (and how do you know they agree with each other?\") Listen for multiple consoles, manual reconciliation, or \"we're not 100% sure.\" Signals policy sprawl.\n\"If an attacker landed on a workload in your data center, how far could they move before something noticed?\", Listen for flat network segments or perimeter-only thinking.\n\"Do you have visibility into what's happening inside encrypted traffic today?\", Listen for reliance on full decryption (a performance/privacy tradeoff) or no encrypted-traffic visibility at all."
    },
    {
      "id": "s34",
      "title": "Getting Started with IQ",
      "bullets": [
        "Simplified on-boarding",
        "Create IQ Account",
        "Add Service Contracts",
        "Collect Telemetry"
      ],
      "notes": "Key Outcomes to focus on:\nSingle operational plane across Networking, Security, AI Infrastructure, Observability, and Collaboration, plus connected third-party systems\nGives teams and AI agents shared context (identity, tenancy, assets, topology, telemetry, zero trust policy) instead of stitched-together data\nThe foundation everything else in this workshop sits on, Hybrid Mesh Firewall policy, Cisco IQ insights, and the agentic SOC all run on this common plane\nExtensible: custom apps, agents, and integrations can be built on top rather than boxing teams into one console\nExample Talk Track:\n\"Everything we're covering today (inventory, exposure, segmentation policy, agentic workflows) has to live somewhere in common, or it's just another silo. Cloud Control is that common plane. It brings Meraki, Catalyst SD-WAN, Nexus Dashboard, Splunk, ThousandEyes, IQ, and more into one operational environment, so your team and Cisco's AI agents work from the same picture of your environment instead of different ones.\"\n3 questions to ask and what to listen for:\n\"How many different consoles does your team log into on a bad day?\", Listen for tool sprawl and \"swivel-chair\" operations.\n\"When something breaks, how long does it take to even agree on what changed?\", Listen for fragmented change history or no shared topology/asset view.\n\"Are you exploring AI agents or copilots for network/security ops? Who decides what data they can access?\" (Listen for interest in AgenticOps paired with unease about ungoverned agent access) Cloud Control's context-and-control model answers this directly."
    },
    {
      "id": "s35",
      "title": "Cisco IQ Data Connectors",
      "bullets": [
        "Collection of telemetry such as software version and configuration",
        "Intersight",
        "Meraki",
        "Catalyst SDWAN",
        "Webex",
        "IQ Link",
        "On Prem Devices",
        "Cisco IQ SaaS"
      ],
      "notes": ""
    },
    {
      "id": "s36",
      "title": "Cisco IQ",
      "bullets": [
        "Exposure Assessment",
        "Inventory Visibility",
        "Complete asset visibility",
        "End of Life (EoL), Last Day of Support (LDoS) visibility",
        "Personalized asset support tier information"
      ],
      "notes": "Key Outcomes to focus on:\nMaps real application dependencies (network, cloud, endpoint telemetry) instead of guessing what talks to what\nUses AI to recommend precise, least-privilege micro-segmentation policy instead of hand-written rules\nEnforces boundaries that stop lateral movement at the workload/process level\nAdds vulnerability and threat forensics on top of the segmentation fabric\nExample Talk Track:\n\"You can't segment what you can't see. Secure Workload discovers actual application flows (which services really talk to which, across network, cloud, and endpoint telemetry) so you're not guessing which connections are safe to cut. It then uses AI to turn that map into precise, least-privilege policy recommendations, so your team isn't hand-writing thousands of firewall rules. That's how you contain a breach at the workload instead of watching it walk across your data center.”\n3 questions to ask and what to listen for:\n\"If I asked your team to draw exactly what talks to what in your data center today, could they?\", Listen for outdated diagrams or reliance on tribal knowledge.\n\"Have you ever delayed a segmentation project because you were worried about breaking something?\" (Listen for fear of outages from overly aggressive policy) Secure Workload's dependency mapping reduces that risk.\n\"How do you currently decide which application flows are actually necessary versus just historically allowed?\", \"We've just always allowed it\" is a red flag for accumulated, overly broad access."
    },
    {
      "id": "s37",
      "title": "Collapse the discover, assess, act loop",
      "bullets": [
        "Exposure Assessment",
        "Critical exposure remediation guidance",
        "Threat mapping and risk scoring",
        "Prioritized criticality and remediation",
        "Automate and de-risk OS upgrade and patch velocity and remediation"
      ],
      "notes": "Differentiator: Automated Policy Lifecycle Management across Cisco and third-party network security devices"
    },
    {
      "id": "s38",
      "title": "Proactive lifecycle refresh",
      "bullets": [
        "Exposure Assessment",
        "Modernization lifecycle insights",
        "Lifecycle status visibility",
        "Lifecycle mapping and risk impact",
        "Tailored remediation paths",
        "For complex remediations or modernization projects"
      ],
      "notes": "Now lets look forward and see the exciting new features coming in next release slated for end of this year.\nEvery product today has to be enriched with AI to stay afloat and capture the customer.\nWe have CINDY our AI Assistant to help us reach there. Cindy is not just AI Assistant but also helps us with some cumbersome tasks like Automation of ADM\nLets roll a Video clip to watch it in action\n<Video1>\nWith Cindy, it can run ADM in background automagically and give you the discovered policy changes, so we give customer ability to add/change the discovered policy with help of AI Automation, we call them AI Suggested policies.\nAlong side policy discovery, Cindy makes it more easy for Compliance, Reporting and Policy Analysis.\nLets roll another Video clip to watch it in action\n<Video2>\nWith AI it can discover new communication, the escaped flows and recommends if its need to be added to policy, analyze them so Customer can further decide to make changes.\nWith AI We also bring the Ability to discover shadow policies.\nWe suggest to take advantage of these upcoming innovations\nThese handy and trendy features makes CSW more attractive and helpful to reach your segmentation goals."
    },
    {
      "id": "s39",
      "title": "Focused, Prioritized Upgrades or Refresh",
      "bullets": [
        "Assets that cannot be patched or upgraded should be replaced. Prioritize based on exposure.",
        "Prioritize by exposure, for example, assets that are reachable via the internet and business criticality, not severity score alone",
        "Immediately prioritize upgrades for most exposed assets",
        "Utilize Cisco operational platforms to plan and execute upgrades safely (ie. Firewall upgrade planner)",
        "Devices that have reached LDoS or end of software maintenance releases should be replaced as soon as possible."
      ],
      "notes": "This is the business value in one equation: active exposure days reduced equals time to patch minus time to Shield.\nWithout Live Protect, exposure continues until fixed software is tested, approved, and deployed. That can take days, weeks, or longer depending on the environment, maintenance windows, and operational risk.\nWith Live Protect, when a Cisco-validated Vulnerability Shield is available for the supported product and release, teams can reduce exposure before the full patch window completes.\nThe key message is not “patch less.” The key message is “reduce exposure sooner.” Live Protect closes the exposure gap, not the patching process."
    },
    {
      "id": "s40",
      "title": "Foundational Practices",
      "bullets": [
        "Reduce attack surface ahead of the next AI-accelerated disclosure",
        "Align to Cisco’s Disclosure Cadence",
        "1st & 3rd Wednesday, 7-day advance notice",
        "CWE-bundled fixes, not one-off CVEs",
        "Where possible, run current, hardened releases",
        "Ensure Safe, Automated Execution",
        "Pre-stage maintenance windows",
        "Plan staged/canary rollouts for critical assets",
        "ISSU / xFSU / HA to minimize downtime",
        "Rehearsed rollback and post-change validation"
      ],
      "notes": "Key Outcomes to focus on:\nAdvanced intrusion prevention (Snort3) informed by Cisco Talos threat intelligence, blocks known exploit activity, malware, and C2 traffic\nEncrypted Visibility Engine inspects for threats in encrypted traffic without full decryption\nHigh-performance enforcement at ingress, egress, data center, cloud, and internal segmentation points\nBuys time when a patch isn't ready: shields exposed systems from known exploit patterns while the real fix is validated and deployed\nExample Talk Track:\n\"When a patch can't be applied on day one, Secure Firewall becomes your bridge. It uses Snort3 IPS and Talos intelligence to block known exploit patterns hitting a vulnerable system, and the Encrypted Visibility Engine gives you visibility into encrypted sessions without paying the cost of decrypting everything. It's not a replacement for patching, it's what keeps you safe in the gap between disclosure and remediation.”\n3 questions to ask and what to listen for:\n\"When an advisory drops for something you can't patch this week, what's your immediate move?\" (Listen for \"we just wait and hope\") no compensating control today.\n\"How much of your traffic is encrypted today, and how do you get visibility into it?\", Listen for full decryption everywhere (performance/compliance pain) or no encrypted visibility at all.\n\"Is your threat intelligence built into your enforcement point, or bolted on separately?\", Listen for stale, manually-updated signature sets."
    },
    {
      "id": "s41",
      "title": "Segment & Contain to Shrink the Blast Radius",
      "bullets": [
        "Not every compromise can be prevented, segmentation limits how far an attacker can move once inside",
        "Reduce reachability to high-priority assets: allow only required communications",
        "Shield vulnerable systems and critical apps from exploit attempts (Firewall and IPS)",
        "Break lateral movement along high-priority paths with least-privilege enforcement",
        "Build a phased segmentation roadmap, start with highest-risk assets",
        "In cases where a device cannot be updated/patched/upgraded (e.g., Internet of Things (IoT) devices, operational technology (OT), past LDoS, Cisco recommends you isolate the device through segmentation and apply security controls as available."
      ],
      "notes": "Key Outcomes to focus on:\neBPF-based runtime visibility and enforcement purpose-built for Kubernetes and cloud-native workloads\nReal-time detection and blocking of malicious activity at runtime, not just at the network perimeter\nIdentity-aware policies protect infrastructure in minutes with pre-built rulesets, fast time-to-protect\nLets teams observe exploit behavior and apply targeted controls (process, network, file access) while a permanent fix is tested\nExample Talk Track: \"As workloads move to Kubernetes, traditional network-layer segmentation stops being enough, you need visibility inside the workload itself. Isovalent uses eBPF to see and enforce at the kernel level, in real time, so if something starts behaving like an exploit (spawning an unexpected process, reaching out somewhere it shouldn't) you can shut it down before it becomes a real compromise, without waiting for a patch cycle.”\n3 questions to ask and what to listen for:\n\"How much of your environment runs in Kubernetes or containers today, and how is that traffic secured versus your traditional network?\", \"We haven't extended segmentation there yet\" is a common gap.\n\"If a container was compromised, would you see it at the process level, or only after it showed up on the network?\", Listen for visibility limited to the network layer only.\n\"How long does it typically take to roll out a new security policy to a cloud-native workload?\", Slow, manual processes contrast sharply with a \"minutes\" story."
    },
    {
      "id": "s42",
      "title": "Cisco’s Segmentation advantage",
      "bullets": [
        "Establish broad, identity-aware trust boundaries",
        "Prevent lateral movement between resources",
        "Protect legacy, traditional, and AI workloads",
        "One Connected Segmentation Architecture",
        "Firewall",
        "Secure Network",
        "Analytics",
        "Identity Services",
        "Engine",
        "Smart Switch",
        "Workload Agent",
        "Isovalent",
        "Segmentation across campus, datacenter, and AI infrastructure",
        "Campus & Branch Network",
        "Data Center Network",
        "Applications"
      ],
      "notes": ""
    },
    {
      "id": "s43",
      "title": "Cisco Hybrid Mesh Firewall",
      "bullets": [
        "Unified policy in Cisco Cloud Control",
        "Hypershield",
        "Firewalls",
        "Secure Firewall | Secure Router | 3rd Party",
        "Smart Switches",
        "Workload Agents",
        "Identity Services Engine",
        "Edge",
        "Inspect encrypted traffic for threats",
        "Campus",
        "Segment devices using identity context",
        "Workload",
        "Shield and segment",
        "at process level",
        "Data Center",
        "Segment services even within a rack"
      ],
      "notes": "This slide is the bridge into the five recommendations. Stress that the basics are not obsolete, but manual-only and perimeter-only models are insufficient against faster attacks."
    },
    {
      "id": "s44",
      "title": "One platform. Every domain. The foundation everything else is built on.",
      "bullets": [
        "Meraki • ThousandEyes • Security • Splunk • Nexus Dashboard • Catalyst SD-WAN • Intersight • Webex • IQ • and more",
        "Cisco Cloud Control"
      ],
      "notes": "Key Outcomes to focus on:\nEnd-to-end phishing resistance, from enrollment through authentication, mid-session, and helpdesk reset flows\nDuo Passport replaces vulnerable browser cookies with hardware-backed cryptographic keys, cutting session-hijacking/token-theft risk\nIdentity Intelligence gives one consolidated view across human, non-human, and agentic identities, surfacing dormant, ownerless, and over-scoped accounts\nDirectly addresses the reality that AI now puts credential-phishing and identity-based attacks within reach of far more attackers, not just nation-states\nExample Talk Track:\n\"Identity is how most real breaches actually happen, not exotic zero-days, but phished credentials, stolen tokens, and stale accounts nobody remembered to clean up. Duo closes the human side with phishing-resistant MFA and Passport's hardware-backed session protection, so even a stolen cookie can't be replayed from an attacker's device. Identity Intelligence then gives you one place to see every identity (human, service account, and AI agent) so the accounts with no owner and too much privilege stop being invisible.”\n3 questions to ask and what to listen for:\n\"If I asked how many service accounts or API keys exist in your environment right now, could anyone give a confident number?\", Listen for uncertainty or \"probably a lot we've lost track of.\"\n\"Have you had a phishing or credential-stuffing incident in the last year, even a contained one?\", Listen for near-misses or reliance on SMS/legacy MFA a determined attacker could bypass.\n\"As you adopt AI agents, who owns the decision about what each agent is allowed to access?\", No clear answer signals a need for agent identity governance, which Identity Intelligence extends to."
    },
    {
      "id": "s45",
      "title": "Comprehensive Segmentation",
      "bullets": [
        "Expand protection across users, workloads, and the network.",
        "Campus and branch modernization",
        "Data-center fabric modernization",
        "AI infrastructure build-out",
        "Hybrid Mesh firewall brings together user, workload, network, cloud and AI segmentation",
        "Identity-based Segmentation",
        "Firewall • ISE",
        "Fabric-native security",
        "Smart Switch • Firewall",
        "Cloud-native and AI workloads",
        "Isovalent • Workload Agent",
        "Extend protection to data-center applications",
        "Smart Switch • Workload Agent",
        "Add workload precision and firewall deep inspection",
        "Extend enforcement into the physical fabric",
        "Firewall • Smart Switch"
      ],
      "notes": "The frame for this slide is one sentence: true resilience is not a reaction, it's an architecture. RIS is that architecture, and it's built to mitigate a whole new generation of AI-generated threats, not just to respond to Mythos specifically. The three pillars as one connected capability stack, not three separate offers -- and one clarification on sequencing: Exposure Assessment is the foundational prerequisite, but these three phases aren't strictly linear. They form an iterative cycle that adapts as assessment capabilities expand -- you don't run this once and stop.\nPillar one, Exposure Assessment: an AI-Era Readiness Review that maps the enterprise threat surface, identifies aging and vulnerable assets, assesses Zero Trust readiness, and hands back a prioritized action plan. You cannot defend what you cannot see -- this is the 'see' step.\nPillar two, Infrastructure Modernization: this is where the attack window actually shrinks and closes -- OS upgrades with pre- and post-validation, network refresh, compensating controls, dynamic segmentation, and cryptographic posture review across edge and core. This is also structurally where the largest services scope tends to land, because it's the deepest technical work.\nPillar three, Defense Resiliency: continuous, autonomous protection, delivered as a 24/7/365 managed operational framework. Zero Trust isn't a static architecture, it's an operational loop -- agentic workflows for active threat hunting, continuously refined SOC playbooks, and a shift from real-time alerting toward automated, agentic policy enforcement. This is also where you'd point a CISO for the executive dashboard -- metrics like MTTP, Mean Time to Patch, alongside broader security posture trends.\nEach pillar stands alone, but the value compounds when they're chained -- and see, harden, defend happens to be the natural sequence a customer's own budget cycle tends to follow too."
    },
    {
      "id": "s46",
      "title": "Cisco Secure WorkloadZero Trust based Micro-Segmentation",
      "bullets": [
        "Map application dependencies and prepare segmentation controls.",
        "Discover application flows using network, cloud, and endpoint telemetry",
        "Understand which communications are required for business services and where unnecessary or overly broad paths create risk.",
        "Map workload data flows across the environment",
        "Utilize AI to analyze application behavior and recommend precise security policies",
        "Enforce least-privilege boundaries to stop lateral movement",
        "Vulnerability and threat forensics"
      ],
      "notes": ""
    },
    {
      "id": "s47",
      "title": "Cisco Secure Network AnalyticsModernized Network Detection and Response",
      "bullets": [
        "Analyze telemetry such as NetFlow to help teams understand which systems are communicating, identify anomalous traffic patterns, and surface suspicious movement across the network.",
        "Validate reachability and detect lateral movement",
        "Use the network as a security sensor to find hidden threats",
        "Behavioral and machine learning",
        "Contextual network-wide visibility",
        "Predictive threat analytics"
      ],
      "notes": "Slide goal: Give a single-page reference that maps each pillar to what's included and what's optional with additional details on the deliverables.\nKey takeaways:\nUse this slide for an overview of the offer, its three pillars and what each includes in one single page\nEach pillar includes Cisco IQ Insights within Cisco Support - Standard, plus optional Professional Services.\nPillar 1: Exposure Assessment provides an AI-Era Readiness Review.\nPillar 2: Infrastructure Modernization contains blast radius and manages structural debt.\nPillar 3: Defense Resiliency provides continuous support with agentic responses via Splunk and optional Talos incident response.\nExample Talk Track:\nThis slide gives you the whole offer on one single page, mapped pillar by pillar. Each one includes Cisco IQ Insights within Cisco Support - Standard, plus optional Professional Services when complexity is high.\nUnder Exposure Assessment, you get an AI-Era Readiness Review and a prioritized action plan.\nUnder Infrastructure Modernization, you contain blast radius and manage structural debt, with automated OS upgrades and a Services as Code pipeline.\nUnder Defense Resiliency, you get a continuous support framework with ongoing risk insights, agentic responses via Splunk, and optional Talos incident response for deeper investigations."
    },
    {
      "id": "s48",
      "title": "Temporary Mitigation When Upgrades Can't Happen Yet",
      "bullets": [
        "Every control here is a time-bound bridge to remediation, not a substitute for it",
        "Infrastructure Shields",
        "Cisco Live Protect applies validated runtime \"shields\" against specific CVEs, with no downtime",
        "Shields auto-retire once the permanent fix is applied",
        "Network & App Shielding",
        "Secure Firewall (Snort/SnortML) blocks known exploit activity while a fix is validated",
        "Encrypted Visibility Engine improves visibility without full decryption",
        "Workload Shielding",
        "Isovalent/Tetragon: eBPF-based runtime visibility and enforcement for Kubernetes workloads",
        "Limit egress from vulnerable workloads to reduce callbacks and exfiltration",
        "Increase logging and hunting for exploit attempts on flagged assets"
      ],
      "notes": ""
    },
    {
      "id": "s49",
      "title": "Reduce vulnerability risk without forcing operational disruption",
      "bullets": [
        "LIVE PROTECT",
        "Vulnerability",
        "Stop the attack…",
        "but not the network",
        "CISCO PRODUCTS",
        "Live Protect for supported Cisco devices",
        "Lower exposure",
        "Preserve uptime",
        "Maintain patch discipline"
      ],
      "notes": ""
    },
    {
      "id": "s50",
      "title": "Live Protect closes the exposure gap, not the patching process",
      "bullets": [
        "Without Live Protect",
        "With Live Protect",
        "Exposure continues until fixed software is tested, approved and deployed",
        "Exposure reduced before patch window",
        "Permanent fix still needed",
        "THREAT DISCOVERED",
        "DISCLOSURE / ADVISORY",
        "SHIELD DEPLOYED",
        "PATCH COMPLETE",
        "Time to shield",
        "Active exposure days reduced = Time to Patch – Time to Shield",
        "Time to patch",
        "Cisco-validated Vulnerability Shields reduce exposure while teams complete the permanent software fix",
        "Disclosure, Shield & patch come together. Exception: Zero Days"
      ],
      "notes": ""
    },
    {
      "id": "s51",
      "title": "Cisco FirewallSuperior visibility beyond deep packet inspection",
      "bullets": [
        "Advanced intrustion prevention with Snort3",
        "Encrypted visibility: secure encrypted traffic without decryption",
        "Cisco TALOS global threat intelligence",
        "High performance, high security segmentation",
        "Network intrusion prevention for known exploit patterns while application, dependency, or vendor patches are tested and deployed."
      ],
      "notes": ""
    },
    {
      "id": "s52",
      "title": "Block malicious activity and enforce security policies at runtime",
      "bullets": [
        "Real-time security insights to proactively detect and prevent threats",
        "Identity-aware security policies monitor and protect your entire infrastructure in minutes with pre-built rulesets",
        "Isovalent EnterpriseUniversal networking and security layer for Kubernetes",
        "eBPF-based runtime visibility, enforcement, and shielding for modern workloads",
        "Helps teams observe exploit behavior and apply targeted runtime controls"
      ],
      "notes": ""
    },
    {
      "id": "s53",
      "title": "eBPF – Extended Berkely Packet Filter",
      "bullets": [
        "Makes the kernel programmable in a secure and efficient way",
        "TECSEC-2002",
        "userspace",
        "Kernel",
        "app",
        "Event",
        "System calls",
        "eBPF program",
        "What Javascript is to the browser, eBPF is to the kernel.",
        "eBPF runs in a restricted execution environment",
        "Before eBPF script is compiled:",
        "Verifier ensures things such as memory safety",
        "Hardening process (program execution protection, mitigation against spectre, constant blinding, …)",
        "eBPF can only access pre-approved kernel functions and data structures"
      ],
      "notes": ""
    },
    {
      "id": "s54",
      "title": "Cisco recommends to Balance foundational controls with adaptive, real-time defence capabilities",
      "bullets": [
        "R E C O M M E N D E D M O D E L",
        "For your environment, the goal is to keep strengthening the controls that stop most attacks while adding defenses that can act at machine speed.",
        "FOUNDATIONAL RESILIENCE",
        "Strengthen the controls that still stop most attacks.",
        "Identity and Zero Trust",
        "Phishing-resistant MFA, strong verification, and least privilege.",
        "Operational hygiene",
        "Patch, asset, and configuration management with clear ownership.",
        "Lifecycle discipline",
        "Remove what cannot be patched, supported, or upgraded.",
        "ADAPTIVE DEFENSE",
        "Add controls that act in real time and update independently.",
        "Embedded protection",
        "Inline controls, runtime protections, and updateable exploit shields.",
        "Machine-speed operations",
        "Automated detection, triage, containment, and validation.",
        "AI-assisted defense",
        "Threat hunting, digital twins, and conformance testing.",
        "Source: Cisco Security Guidelines for AI-Era Resilience"
      ],
      "notes": ""
    },
    {
      "id": "s55",
      "title": "Zero Trust & Identity: Close the Gaps",
      "bullets": [
        "You can't protect an identity you don't know exists, and AI now puts nation-state-grade tradecraft within reach of far more attackers",
        "Human Identities",
        "Phishing-resistant MFA (FIDO2/WebAuthn passkeys); prioritize admins, execs, finance, helpdesk first",
        "Just-in-time privileged access with time-boxed, scoped grants",
        "Non-Human Identities",
        "Inventory mapping every service account, key, and token to a human owner",
        "Workload identity instead of static secrets (SPIFFE/SVID, short-lived certs)",
        "Automated decommissioning, no orphaned credentials",
        "Agent Identities",
        "Central directory: every agent gets a verifiable identity, owner, and lifecycle state",
        "Per-action, scoped authorization, never standing credentials",
        "Behavioral baselines with automatic revocation when an agent strays"
      ],
      "notes": ""
    },
    {
      "id": "s56",
      "title": "Cisco Duo and Identity IntelligenceIdentity Security",
      "bullets": [
        "Build resilience against phishing and identity-based attacks",
        "Get a full picture of identity activity",
        "Clean up vulnerable accounts, eliminate risky privileges, and block high-risk access attempts",
        "Gain visibility into and secure agentic activity",
        "Security-first IAM",
        "End-to-End Phishing Resistance",
        "Agentic Identity Security",
        "Visibility across identity landscape with Identity Intelligence"
      ],
      "notes": ""
    },
    {
      "id": "s57",
      "title": "Secure AI Agents & Agentic Workflows",
      "bullets": [
        "Knowing an agent's identity tells you who is acting, it doesn't stop the agent from being turned against you",
        "Red-team agents against injection, jailbreak, and tool-abuse before and after deployment",
        "Govern MCP servers and tools as a managed supply chain",
        "Apply runtime guardrails and prompt/data-loss filtering, independent of what the agent was asked to do",
        "Maintain unified telemetry and automated response to revoke or kill an agent at machine speed"
      ],
      "notes": ""
    },
    {
      "id": "s58",
      "title": "AI SecuritySecurity for AI Models, Agents, Tools, and MCP",
      "bullets": [
        "Red-team AI components and applications for vulnerabilities",
        "Protect AI applications against agentic threats with adaptive guardrails",
        "Real-time enforcement with MCP awareness",
        "Contextual visibility into AI components",
        "Cisco AI Defense",
        "Scan skills, plugins, or MCP",
        "Check LLM pompts, completions, and tool invocations in real time",
        "Scan agent written code for unsafe patterns including command injection",
        "Govern network and file system i/o",
        "DefenseClaw"
      ],
      "notes": ""
    },
    {
      "id": "s59",
      "title": "Harness AI for Defense: The Agentic SOC",
      "bullets": [
        "Attackers increasingly operate at machine speed, security operations need to as well",
        "Build a foundation of visibility: continuous discovery of assets, identity, software, cloud workloads",
        "Prioritize risk, not alert volume",
        "Shift to exposure management: patching alone isn't sufficient",
        "Keep humans in the loop for containment and policy decisions, with full auditability"
      ],
      "notes": ""
    },
    {
      "id": "s60",
      "title": "Splunk Enterprise SecurityPurpose build for the operational reality frontier AI creates",
      "bullets": [
        "Enterprise Security",
        "SIEM + Threat Detection",
        "Correlation, risk scoring, detection lifecycle",
        "Exposure Analytics",
        "Continuous Entity Discovery",
        "Continuous native asset, identity, and cloud workload discovery from telemetry already in Splunk",
        "SOAR",
        "Automated Response",
        "Included for everyone, not gated by per-seat licensing",
        "UEBA",
        "Behavioral Analytics",
        "Native user and entity behavior analytics embedded in the one platform",
        "CISCO Cloud Control",
        "Data Foundation",
        "Access everything from a single unified platform and data layer with CDF",
        "Threat Intelligence Management",
        "Operationalize Threat Intel",
        "Integrated TIM including Cisco Talos, at no additional cost to Splunk Security customers",
        "AI Assistant & MCP Server",
        "Triage Findings and Investigations",
        "Embedded into analyst workflow. SPL authoring, explanation, summarization, documentation, Q&A",
        "Automated Threat Analysis",
        "Gain consistent, comprehensive, high-quality threat analysis fully understand the scope of complex attack chains."
      ],
      "notes": ""
    },
    {
      "id": "s61",
      "title": "Resilient Infrastructure Services",
      "bullets": [],
      "notes": ""
    },
    {
      "id": "s62",
      "title": "Resilient Infrastructure Services",
      "bullets": [
        "Exposure Assessment",
        "AI-Era Readiness Review with prioritized action plan",
        "We evaluate the customer’s infrastructure including aging assets and Zero Trust readiness, to determine their security posture against these new attacks.",
        "Defense Resiliency",
        "Continuous monitoring framework against evolving threats",
        "We implement Agentic workflows for active threat hunting & continuous network hardening in evolving threat landscape.",
        "Infrastructure Modernization",
        "Blast radius contained; structural debt eliminated",
        "We help modernize customer infrastructure, leveraging 40 years of taking care of our customers.",
        "ZTP",
        "ZERO TRUST",
        "PRINCIPLES",
        "EXPOSURE ASSESSMENT",
        "DEFENSE RESILIENCY",
        "INFRASTRUCTURE MODERNIZATION"
      ],
      "notes": ""
    },
    {
      "id": "s63",
      "title": "Comprehensive Path to Resilience across the Lifecycle",
      "bullets": [
        "Cisco Support delivered via Cisco IQ",
        "Standard",
        "Asset inventory for visibility into EoL / LDoS",
        "Personalized field notices and security advisory mapping for vulnerabilities",
        "Insights delivered on criticality of risks and prioritized remediation",
        "Update OS for critical devices",
        "Modernize deployment pipeline w/ Automated Validation Framework and Services as Code",
        "Continuous insights for ongoing risk and exposure",
        "Agentic responses to developing threats via Splunk",
        "+ Cisco Professional Services using Cisco IQ",
        "Transaction",
        "Remediation planning: compensating controls, change windows",
        "Deployment-readiness review for OS upgrades, remediation controls (config, rollback)",
        "OS upgrades: pre/post validation",
        "Network Refresh",
        "Compensating Controls",
        "Network hardening with Zero Trust principles and segmentation",
        "Ongoing network hardening and posture-drift reviews",
        "Splunk SIEM \\ SOAR Playbooks",
        "Cisco Talos Incident Response – Compromise Assessment and Active Threat Hunting",
        "Subscription",
        "AI-Era Readiness Review with prioritized action plan",
        "Exposure Assessment",
        "Infrastructure Modernization",
        "Blast radius contained; manage structural debt",
        "Defense Resiliency",
        "Continuous support framework against evolving threats"
      ],
      "notes": ""
    },
    {
      "id": "s64",
      "title": "Always-on landscape clarityto advance the operating model",
      "bullets": [
        "Mapping the attack surface",
        "Know what assets do you have, what is at risk, and what to do next.",
        "Critical exposure remediation guidance",
        "Collapse the discover, assess, and act loop.",
        "Exposure Assessment",
        "Modernization roadmap insights",
        "Identify and prioritize lifecycle risk with tailored refresh paths.",
        "A comprehensive, step-by-step defender’s playbook"
      ],
      "notes": ""
    },
    {
      "id": "s65",
      "title": "Proactive structural resiliencethrough infrastructure modernization",
      "bullets": [
        "Infrastructure Modernization",
        "Modernize deployment pipeline",
        "Streamline deployment pipeline and automate validation.",
        "Eliminate technical debt",
        "Refresh aging infrastructure, pre/post-OS upgrade validation and segmentation, and Zero Trust principles implementation.",
        "Bringing together AI, automation, and expertise to de-risk and accelerate infrastructure modernization"
      ],
      "notes": ""
    },
    {
      "id": "s66",
      "title": "Defend while modernizing with specialized experts",
      "bullets": [
        "Infrastructure Modernization",
        "Streamlined OS upgrades with pre/post validation: Validate OS upgrades to ensure system integrity, performance, and security.",
        "Strategic network refresh:Conduct remediation planning and systematically identify and replace aging EoL/LDoS, hardware, and software.",
        "Modernize deployment pipeline: Shift to repeatable, automated Infrastructure as Code best practices, with ‘Services as Code’, achieving 93% average network change success rate*",
        "Dynamic segmentation for containment:Dynamic segmentation isolates networks, containing blast radius.",
        "Network hardening with Zero Trust principles: Enforce identity policies, disable insecure interfaces, verify continuously.",
        "Shield assets:",
        "Design and deploy compensating controls to shield unpatchable critical assets.",
        "Defend",
        "Modernize",
        "Accelerate outcomes through expertise of Cisco Professional Services and our partners",
        "*IDC The Business Value of Cisco Services as Code, June 2026"
      ],
      "notes": ""
    },
    {
      "id": "s67",
      "title": "Operations and threat response for elevated security posture",
      "bullets": [
        "Proactive zero-day defense",
        "Engineer for continuous detection and conduct proactive threat hunting.",
        "Autonomous security operations",
        "Validate upgrades and transition to agentic SOC to outpace threats.",
        "Defense Resiliency",
        "Expert-led continuous autonomous defense with AI-driven enforcement"
      ],
      "notes": ""
    },
    {
      "id": "s68",
      "title": "Continuous defense at machine speed with Cisco experts",
      "bullets": [
        "Expert–led posture drift assessments and remediation",
        "Active threat hunting",
        "Dynamic asset visibility and risk insights",
        "Agentic SOC playbooks",
        "Rapid incidentresponse",
        "24x7 support",
        "Proactive zero-day defense",
        "Operations and response",
        "Common Intelligence Foundation",
        "Defense Resiliency",
        "Delivered through Cisco Support – Standard and Professional Services from Cisco or our partners",
        "Cisco IQ",
        "Splunk®",
        "Talos®"
      ],
      "notes": ""
    },
    {
      "id": "s69",
      "title": "OPTIONAL PROFESSIONAL SERVICES",
      "bullets": [
        "OS upgrades: pre/post validation",
        "Network Refresh",
        "Compensating Controls",
        "Network hardening with Zero Trust principles and segmentation",
        "Modernize deployment pipeline with automated validation and Services as Code",
        "Accelerate the path to infrastructure resilience",
        "Cisco Resilient Infrastructure Services",
        "Cisco Support – Standard, incl. Cisco IQ Insights",
        "Asset inventory for visibility into EoL / LDoS",
        "Personalized security advisory mapping",
        "Risk criticality and prioritized remediation",
        "OPTIONAL PROFESSIONAL SERVICES",
        "Remediation planning: compensating controls, change windows",
        "OS upgrade deployment: readiness review, remediation controls (config, rollback)",
        "Exposure Assessment",
        "AI-Era Readiness Review with prioritized action plan",
        "Cisco Support Standard, incl. Cisco IQ Insights",
        "Automated upgrades OS for critical devices",
        "Infrastructure Modernization",
        "Blast radius contained; manage structural debt",
        "Continuous insights for ongoing risk and exposure",
        "Agentic responses for developing threats via Splunk*",
        "Ongoing network hardening and posture-drift reviews",
        "Splunk SIEM \\ SOAR playbooks",
        "Cisco Talos IR for deeper investigations",
        "Defense Resiliency",
        "Continuous support framework against evolving threats"
      ],
      "notes": ""
    },
    {
      "id": "s70",
      "title": "Slide 80",
      "bullets": [],
      "notes": ""
    }
  ]
} as const;
